import { Box } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ResponsiveContainer } from 'recharts'
import { MappedChartType } from '../../../system-data-handler/types'

const useStyles = makeStyles()(theme => ({
  bottomCharts: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  responsiveCharts: {
    display: 'flex',
    flexGrow: 1,
    paddingBottom: 0,
  },
  roundedPaper: {
    backgroundColor: theme.palette.background.paper,
  },
}))

interface Props {
  customCharts: MappedChartType[]
}

/**
 * Component for the custom charts added by the user
 */
const CustomCharts: React.FC<Props> = ({ customCharts }) => {
  const { classes, cx } = useStyles()

  const mappedCharts = customCharts.map(chart => {
    return (
      <Box key={chart.id} className={cx(classes.bottomCharts, classes.roundedPaper)}>
        {chart.node}
      </Box>
    )
  })

  return (
    <Box className={classes.responsiveCharts}>
      <ResponsiveContainer height={'100%'}>
        <>{mappedCharts}</>
      </ResponsiveContainer>
    </Box>
  )
}

export default CustomCharts
